import { OtpViewModel } from '@apis/model';
import { InfoResponse } from '@ul/api';

export const toOtpViewModel = (response: InfoResponse): OtpViewModel | undefined => {
    const { otpInfo } = response;
    if (!otpInfo) {
        return;
    }

    return {
        target: otpInfo.target,
        token: otpInfo.token,
        otpType: otpInfo.otpType,
        refCode: otpInfo.refCode,
    };
};
